module.exports = __webpack_public_path__ + "img/printer.90d97452.svg";